import { useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery } from '@/hooks/search/search.gql.impl';
import { parseKeywordIntegratedSearchHospital } from '@/parsers/search';
import { HospitalSortType } from '@/types/bff/gql-schema';

const KEYWORD_SEARCH_SIZE = 4;

const useGetKeywordIntegratedSearchHospital = (
  keyword: string,
  latitude: number,
  longitude: number,
) => {
  const { data: keywordSearchHospital, isLoading: isKeywordSearchHospitalLoading } =
    useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery(
      {
        request: {
          keyword,
          size: KEYWORD_SEARCH_SIZE,
          sortType: HospitalSortType.Distance,
          geoPoint: {
            latitude,
            longitude,
          },
        },
      },
      {
        select: parseKeywordIntegratedSearchHospital,
        enabled: keyword.length > 1,
      },
    );

  return {
    keywordSearchHospital,
    isKeywordSearchHospitalLoading,
  };
};

export default useGetKeywordIntegratedSearchHospital;
